import React from 'react';

const initialState = {
    socketId: '',
    accessLevelList: [],
    accessLevelListLoading: true,
    onBoardingFieldStep: 1,
    welcomeKitValidator: null,
    experienceValidator: null,
    compensationValidator: null,
    onBoardingJobInfo: {},
    policySelection: {},
    logs: []
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'UAC_GET_LIST': {
            return {...state, accessLevelList: action?.payload?.uac, accessLevelListLoading: false,};
        }
        case 'CHANGE_ON_BOARDING_FIELD_STEP': {
            return {...state, onBoardingFieldStep: action?.payload};
        }
        case 'SET_WELCOME_KIT_VALIDATOR': {
            return {...state, welcomeKitValidator: action.payload};
        }
        case 'SET_EXPERIENCE_VALIDATOR': {
            return {...state, experienceValidator: action.payload};
        }
        case 'SET_COMPENSATION_VALIDATOR': {
            return {...state, compensationValidator: action.payload};
        }
        case 'SET_JOB_INFO_DATA': {
            return {...state, onBoardingJobInfo: action.payload};
        }
        case 'SET_POLICY_SELECTION': {
            return {...state, policySelection: action.payload};
        }
        case 'SET_LOGS': {
            return {...state, logs: [...state.logs, action.payload]};
        }
        default: {
            return state;
        }
    }
}
